import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  heading: {
    id: 'course-authoring.pages-resources.heading',
    defaultMessage: 'Páginas y recursos',
  },
  settings: {
    id: 'course-authoring.pages-resources.resources.settings.button',
    defaultMessage: 'Ajustes',
  },
  viewLiveButton: {
    id: 'course-authoring.pages-resources.viewLive.button',
    defaultMessage: 'Ver en directo',
  },
  errorShowingConfiguration: {
    id: 'course-authoring.pages-resources.courseAppPlugin.errorMessage',
    defaultMessage: 'Se produjo un error al cargar la interfaz de configuración de esa aplicación.',
  },
  enabled: {
    id: 'course-authoring.badge.enabled',
    defaultMessage: 'Activada',
  },
  contentPermissions: {
    id: 'course-authoring.pages-resources.content-permissions.heading',
    defaultMessage: 'Permisos de contenido',
  },
});

export default messages;
